import ACFFlexibleContentLayoutLoader from '../../../utils/acf/flexible-content-layout-loader';
import setupNativePlantSearch from '../../sections/native-plant-search';
import setupWeeklyWateringAdvice from '../../sections/weekly-watering-advice';
import setupVideoGalleries from '../../sections/video-gallery';


/**
 *
 * @return {ACFFlexibleContentLayoutLoader}
 */
const getFlexibleContentLayoutLoader = (): ACFFlexibleContentLayoutLoader =>
{
	return new ACFFlexibleContentLayoutLoader( {
		layoutLoaders: {
			'native_plant_search':    () => setupNativePlantSearch(),
			'weekly_watering_advice': () => setupWeeklyWateringAdvice(),
			'video_gallery':          () => setupVideoGalleries(),
		}
	} );
};


/**
 *
 */
export default getFlexibleContentLayoutLoader;